var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "219px",
    height: "147px",
    viewBox: "0 0 219 147",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_Designer_by46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0199541%",
    y1: "99.9999129%",
    x2: "50.0199541%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "53.514%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9999915%",
    y1: "99.9999925%",
    x2: "49.9999915%",
    y2: "-7.53146442e-06%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "53.514%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9999976%",
    y1: "100%",
    x2: "49.9999976%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "53.514%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Online-Education",
    transform: "translate(-718.000000, -79.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(295.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Designer_by46",
    transform: "translate(425.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5588556,121.128347 C31.051916,127.203479 25.7714439,131 25.7714439,131 C25.7714439,131 22.9342048,124.946786 24.4411444,118.871653 C25.948084,112.796521 31.2285561,109 31.2285561,109 C31.2285561,109 34.0657952,115.053214 32.5588556,121.128347 Z",
    id: "Shape",
    fill: "#373E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9125933,119.836949 C25.4943181,124.255225 25,131 25,131 C25,131 31.6691247,130.581331 36.087409,126.163053 C40.5056932,121.744775 41,115 41,115 C41,115 34.3308617,115.418671 29.9125933,119.836949 Z",
    id: "Shape",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#454D5E",
    x: 15,
    y: 129,
    width: 24,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    transform: "translate(184.000000, 120.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0371415,3.69427312 L19.0371415,0.168722581 L0.1212,0.168722581 L0.1212,16.4744086 C0.1212,17.3860689 0.509820862,18.26039 1.20157043,18.9050311 C1.89332,19.5496723 2.83153376,19.911828 3.80981538,19.911828 L15.3485377,19.911828 C17.3857037,19.911828 19.0371531,18.3728429 19.0371531,16.4744086 L19.0371531,12.8607075 C21.7496489,12.8558101 23.9457782,10.805269 23.9457782,8.27749032 C23.9457782,5.7497117 21.7496489,3.69917059 19.0371531,3.69427312 L19.0371415,3.69427312 Z M19.0371415,11.097929 L19.0371415,5.45704731 C20.7086589,5.45704731 22.0636915,6.7198017 22.0636915,8.27748817 C22.0636915,9.83517465 20.7086589,11.097929 19.0371415,11.097929 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.500066,125 C198.680012,125 197.039173,126.096374 196.342668,127.777884 C195.646164,129.459395 196.03116,131.394897 197.318133,132.681869 C198.605105,133.968841 200.540608,134.353836 202.222118,133.657331 C203.903628,132.960826 205.000001,131.319986 205,129.499932 C204.999996,127.014689 202.985309,125.000003 200.500066,125 Z M200.500066,132.269123 C199.380032,132.269124 198.370284,131.594433 197.941665,130.559657 C197.513046,129.524881 197.749966,128.333802 198.541949,127.541819 C199.333932,126.749835 200.52501,126.512914 201.559787,126.941532 C202.594563,127.370151 203.269255,128.379898 203.269255,129.499932 C203.269255,131.029313 202.029447,132.269122 200.500066,132.269123 Z",
    id: "Shape",
    fill: "#596377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.500066,125 C198.680012,125 197.039173,126.096374 196.342668,127.777884 C195.646164,129.459395 196.03116,131.394897 197.318133,132.681869 C198.605105,133.968841 200.540608,134.353836 202.222118,133.657331 C203.903628,132.960826 205.000001,131.319986 205,129.499932 C204.999996,127.014689 202.985309,125.000003 200.500066,125 Z M200.500066,132.269123 C199.380032,132.269124 198.370284,131.594433 197.941665,130.559657 C197.513046,129.524881 197.749966,128.333802 198.541949,127.541819 C199.333932,126.749835 200.52501,126.512914 201.559787,126.941532 C202.594563,127.370151 203.269255,128.379898 203.269255,129.499932 C203.269255,131.029313 202.029447,132.269122 200.500066,132.269123 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,121 L201,121 L201,136.906285 C201,138.062612 200.008451,139 198.785314,139 L186.214686,139 C184.991549,139 184,138.062612 184,136.906285 L184,121 Z",
    id: "Shape",
    fill: "#596377"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#292453",
    opacity: 0.850111607,
    x: 0,
    y: 139,
    width: 219,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    transform: "translate(70.000000, 0.000000)",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6220605,88.4144589 C71.2919745,79.9610322 58.082145,73.7880571 48.1427253,72.4193088 C48.1440681,72.3569412 48.1474519,72.2950836 48.1474519,72.2323782 L48.1474519,64.9961447 C48.1580285,64.9922683 48.1689005,64.9890271 48.1794547,64.9851283 L48.1794547,64.7108579 C55.3268481,62.0540733 60.8562651,56.2617572 63.1761299,49.0011579 C63.7904372,47.8910262 64.3251525,46.7387227 64.7762469,45.5529293 C65.8372975,45.1667855 66.6386775,43.4179486 66.6386775,41.3166099 C66.6426321,40.5978399 66.5417513,39.8823313 66.3392161,39.1926455 C66.4694587,38.1224298 66.5358876,37.0454175 66.5381506,35.9673161 C66.546523,28.3454061 63.3173946,21.0782185 57.654209,15.9739113 C57.7373649,15.5409654 57.7655783,15.0992681 57.7381817,14.6592678 C57.5133271,11.1861051 53.8017684,8.82650961 50.3231835,8.66868697 C52.1987165,6.54205253 52.6806626,3.52574312 51.5611046,0.921030921 C49.343033,4.15087211 44.7893656,4.49420276 40.869992,4.51960434 C42.5611627,3.8649925 43.3222013,1.52287342 42.3385976,8.9473684e-06 C38.2422909,5.48784605 30.2569687,6.50405013 25.3847589,11.317023 C24.3233191,12.369756 23.4337431,13.5824572 22.7484954,14.91087 C16.3341575,20.0182735 12.6001323,27.7704777 12.6061799,35.9673161 C12.6083742,37.0356455 12.6735619,38.1029173 12.8014039,39.16358 C12.5925274,39.8620495 12.4884386,40.5876183 12.4925341,41.3166099 C12.4925341,43.4276095 13.3014516,45.1818462 14.3697509,45.5571659 C14.8227229,46.7470573 15.3598985,47.9031966 15.9772017,49.0168113 C18.2885894,56.2343136 23.773485,62.0002004 30.8688763,64.6713866 L30.8688763,72.2323871 C30.8688763,72.2906009 30.8721191,72.3480117 30.8732627,72.4059504 C20.8961602,73.7512051 7.58079524,79.9727779 5.27142382,88.4941845 C3.27710575,95.8530684 1.14828402,103.934712 0.0890573938,108.679622 C9.16807533,115.055859 28.2186859,118.799859 40.1577656,118.799859 C51.5012928,118.799859 70.0418722,115.420628 78.8535837,109.614627 C77.8991137,104.401026 75.7031286,95.9645079 73.6220605,88.4144589 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.171062,117 C121.260465,117 139.385707,113.741468 148,108.14287 C147.066934,103.1155 144.920136,94.980333 142.885682,87.6999658 C140.294688,78.427993 123.94189,72 114.186784,72 L104.786382,72 C95.0010384,72 78.62465,78.465188 76.0662664,87.776849 C74.1166321,94.8728686 72.0354875,102.665835 71,107.241251 C79.875617,113.389739 98.4994486,117 110.171062,117 Z",
    id: "Shape",
    fill: "#454D5E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#596377",
    cx: 109,
    cy: 37,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,59 L118,59 L118,72.538471 C118,77.2116444 114.194427,81 109.500014,81 L109.499998,81 C104.805585,81 101.000011,77.2116444 101.000011,72.538471 L101,59 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.438418,58 L115.561568,58 C116.908277,58 118,59.0867829 118,60.4273976 L118,71.538471 C118,76.2116444 114.194424,80 109.500008,80 L109.499992,80 C104.805576,80 101,76.2116444 101,71.538471 L101,60.4273953 C101.000001,59.0867869 102.091716,58.0000075 103.438418,58 Z",
    id: "Shape",
    fill: "#F0F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,64.706377 C106.478895,66.4175892 112.509872,66.4315243 118,64.7456571 L118,63 L101,63 L101,64.706377 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F0F0F1",
    cx: 110.5,
    cy: 42,
    rx: 24.5,
    ry: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,20.9176474 C93,20.9176474 103.207042,41.0376463 132,29.3502927 L125.296876,19.1423532 L113.414065,15 L93,20.9176474 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,19.9176474 C93,19.9176474 103.20703,40.0376463 132,28.3502927 L125.296876,18.1423488 L113.414063,14 L93,19.9176474 Z",
    id: "Shape",
    fill: "#64728F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4966835,18.0272341 C93.1726292,15.9841006 94.3410813,14.1291314 95.9038827,12.6181555 C100.585214,8.10239457 108.257694,7.14895892 112.193517,2 C113.138598,3.42883398 112.40737,5.62631581 110.782457,6.240497 C114.548283,6.21665909 118.923557,5.8945439 121.054718,2.86414957 C122.130418,5.30801489 121.667354,8.13806096 119.865297,10.1333722 C123.207593,10.2814405 126.773755,12.4953219 126.989788,15.7540005 C127.133706,17.9249554 125.739023,19.9804062 123.911177,21.2254358 C122.083331,22.4704653 119.871888,23.0420181 117.69521,23.5104197 C111.341286,24.8777238 88.3505452,30.6086304 92.4966835,18.0272341 Z",
    id: "Shape",
    fill: "#596377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,43 L134.350312,43 L121.710578,54.0475167 C109.533275,48.4480893 100.592978,54.0475167 100.592978,54.0475167 L87.3366713,43.4540076 L86,43.618902 C86.3770298,56.75735 97.4240407,67.1670477 110.810405,66.9979692 C124.196768,66.8288907 134.96736,56.1436225 135,43 Z M110.458134,58.2849212 C105.690811,58.2849212 101.82612,57.3363252 101.82612,56.1662189 C101.82612,54.9961126 105.690811,54.0475167 110.458134,54.0475167 C115.225457,54.0475167 119.090148,54.9960991 119.090148,56.1662189 C119.090148,57.3363388 115.225457,58.2849212 110.458134,58.2849212 Z",
    id: "Shape",
    fill: "#596377"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F0F0F1",
    cx: 85.5,
    cy: 43,
    rx: 2.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F0F0F1",
    cx: 134.5,
    cy: 43,
    rx: 2.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    transform: "translate(62.000000, 84.000000)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0355264493,
    y: 0.156172594,
    width: 92.8032443,
    height: 52.7547652,
    rx: 14.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#D8DCEF",
    x: 65,
    y: 86,
    width: 90,
    height: 52,
    rx: 26
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 110.5,
    cy: 112.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.305083,119 L198.305083,133.866071 C198.305082,135.596891 196.825347,136.999998 195,137 L196.694915,137 C198.520262,136.999998 199.999997,135.596891 200,133.866071 L200,119 L198.305083,119 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.790777,108.454943 C186.512421,108.50624 186.198384,108.587147 186.061982,108.853461 C185.845505,109.276114 186.237787,109.752657 186.595769,110.04308 C187.257121,110.579622 187.954185,111.106653 188.403731,111.855521 C188.853276,112.604388 188.994499,113.649473 188.503083,114.367183 C187.861426,115.304318 186.330572,115.505906 186.18242,116.659307 C186.087308,117.399779 186.68169,118.031618 187.283959,118.403173 C188.770498,119.320264 190.686842,119.564928 191.763605,121 C192.209032,120.013532 193.205339,119.443302 194.198432,119.199792 C195.191526,118.956283 196.223359,118.97446 197.230244,118.809269 C197.555284,118.755943 197.921444,118.649027 198.066768,118.331388 C198.348233,117.716183 197.546033,116.978337 197.822908,116.360721 C198.033637,115.890649 198.65268,115.927153 199.104737,115.738905 C199.840809,115.432383 200.144343,114.412125 199.935429,113.592498 C199.726515,112.772871 199.136398,112.132336 198.515864,111.607178 C196.843505,110.19187 194.832599,109.35954 192.798691,108.76086 C191.852733,108.482418 190.742289,108.045768 189.759775,108.003557 C188.811287,107.962816 187.729549,108.281977 186.790777,108.454943 Z",
    id: "Shape",
    fill: "#C7D3F3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.7627888fa14de65cf5d6ecfffe6676a6.svg";
export { ForwardRef as ReactComponent };